module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10236.38b07ad7.jpg";